import { AutoSuggestData, AutoSuggestRequest, FetchtripTagRequest, TripTagsData } from "../../pages/listing/interface/bizType"
import { formatEmployees } from "../../utils/BizUtils";
import { getCookie } from "../../utils/trainUtils";
import { railsConfig } from "../railsConfig";

export const fetchAutoSuggestData = async (req: AutoSuggestRequest): Promise<AutoSuggestData> => {
  const { email} = req
  const url = railsConfig.autoSuggestUrl.replace('email', email);
  const mmtAuth = getCookie('mmt-auth')
  let retData: AutoSuggestData = {
    isSuccess: false,
    isFailed: false,
    isCalling: true,
    empList: []
  }
  try {
    const response: { json: () => any } = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth
      }
    })
    const result = await response.json()
    retData = formatEmployees(result.employees)
  } catch (error) {
    retData.isFailed = true
  }
  retData.isCalling = false
  return retData
}

export const fetchtripTagData = async (req: FetchtripTagRequest): Promise<TripTagsData> => {
  let result = {attributeList: [], captureGstn: true};
  const { primaryPaxEmailId = '', sourceLocationCode = '' } = req;
  try {
    const mmtAuth = getCookie('mmt-auth')
    const url = railsConfig.tripTagUrl;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth
      },
      body: JSON.stringify({
        primaryPassengerEmailId: primaryPaxEmailId,
        sourceStationCode: sourceLocationCode,
      })
    });
    result = await response.json()
  } catch (error) {
    console.error("Error in fetching TripTags Data: ", error);
  }
  return result;
}

export const fetchPaxDetailsFromRequisitionId = async (
  requisitionId: String
): Promise<any> => {
  const url = railsConfig.requisitionDetailsUrl + requisitionId;
  const mmtAuth = getCookie("mmt-auth") || "";
  try {
    const response: { json: () => any } = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "mmt-auth": mmtAuth
      }
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return null;
  }
};
